import React, {useState, useEffect} from 'react';
import Skeleton from 'react-loading-skeleton';
import { NavLink } from 'react-router-dom';



const Accessories = () =>{
    const [data, setData]  = useState([]);
     const [filter, setFilter] = useState(data);
    const [loading, setLoading] = useState(false)
    let componentMounted = true;
    useEffect(() =>{
        const getProducts =async () =>{
          setLoading(true)

   const response = await fetch("https://fakestoreapi.com/products");
     if(componentMounted){
    setData(await response.clone().json());
    setFilter(await response.json());
    setLoading(false);
    console.log(filter)
 }
return () =>
    componentMounted = false;

        }
        getProducts();
     } ,[]);

     const Loading = () =>{
    return(<>
           
           <div className="col-md-3">
    <Skeleton height= {350}/>
</div>
<div className="col-md-3">
    <Skeleton height= {350}/>
</div>
<div className="col-md-3">
    <Skeleton height= {350}/>
</div>
<div className="col-md-3">
    <Skeleton height= {350}/>
</div>
  
        </>);}

const filterProduct = (cat) =>{
const updatedList = data.filter((x)=>x.category === cat);
setFilter(updatedList)}

const ShowProducts  = () =>{
  return(<><div className= "buttons d-felx justify-content-center mb-5 pb-5">
     <button className= "btn btn-outline-dark me-2 " onClick={()=>setFilter(data)} >All</button>
     <button className= "btn btn-outline-dark me-2" onClick={()=>filterProduct("men's clothing")}>Men's Clothing</button>
     <button className= "btn btn-outline-dark me-2" onClick={()=>filterProduct("women's clothing")}>Women's Clothing</button>
     <button className= "btn btn-outline-dark me-2" onClick={()=>filterProduct("jewelery")}>jewelery</button>
 
</div>

{filter.map((product) =>{
   return (
     <>
       <div className="col-md-3">
         <div className="card h-100 text-center p-4" key={product.id}>
           <img src={product.image} className="card-img-top h-100 w-auto" alt={product.title}  />
           <div className="card-body">
             <h5 className="card-title mb-0">{product.title.substring(0 ,12)} ....</h5>
             <p className= "card-text lead fw-bold">
               ${product.price} 
             </p>
             <NavLink to={`/accessories/${product.id}`} className="btn  btn-outline-dark ">
    Buy Now
             </NavLink>
           </div>
           </div>
           </div>


</>);

   })}
   </> ); };

    return (

         <div>
          <div className= "container my-5 py-5">
    <div className="row">
       

        <div className="row justify-content-center">
    {loading ? <Loading/> : <ShowProducts/>}
</div>
                        

    </div>
</div>

        </div>
     );}

export default Accessories;
